var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.083 13.334h-.922l-.326-.316a7.583 7.583 0 0 0 1.726-6.23C15.013 3.546 12.306.956 9.04.559A7.59 7.59 0 0 0 .558 9.04c.397 3.267 2.987 5.974 6.23 6.522a7.584 7.584 0 0 0 6.23-1.727l.315.327v.921l4.958 4.959c.479.478 1.26.478 1.739 0a1.232 1.232 0 0 0 0-1.739l-4.947-4.97Zm-7 0a5.243 5.243 0 0 1-5.25-5.25 5.243 5.243 0 0 1 5.25-5.25 5.243 5.243 0 0 1 5.25 5.25 5.243 5.243 0 0 1-5.25 5.25Z"
  })));
};
export default SvgSearch;